import { createSetters } from 'map-state-vmodel'

/**
 * Authentication: IDs, Tokens are added here
 */
// initial state
const state = {
  token: null,
  id: null, //user_id
  account_id: null //account_id
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  ...createSetters(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
